import { Spark, SparkelloImage } from 'sparkello-core';

export interface WebSparkPropsInterface {
  id: string;
  displayName: string;
  description?: string;
  image: SparkelloImage;
  moreImages?: Array<SparkelloImage>;
  visibility?: string;
  dateCreated?: Date;
  lastUpdated?: Date;
}

export class WebSpark extends Spark {
  public constructor(props: WebSparkPropsInterface) {
    super(props.id, props.displayName);
    this.description = props?.description;
    this.image = props?.image;
    this.moreImages = props?.moreImages;
    this.visibility = props?.visibility;
    this.dateCreated = props?.dateCreated;
    this.lastUpdated = props?.lastUpdated;
  }

  public clone(): WebSpark {
    const newSpark: WebSpark = super.clone();
    newSpark.clone = this.clone;
    return newSpark;
  }
}
